import React from 'react';
import ReactPlayer from 'react-player';
import { useParams } from 'react-router';
import { PropTypes } from 'prop-types';
import { Box } from '@mui/material';
import { getTracks } from './tracks';

Video2Viewer.propTypes = {
  preview: PropTypes.any,
};

export default function Video2Viewer({ preview }) {
  const { id } = useParams();

  return (
    <Box sx={{ overflow: 'hidden', width: '100%', height: '100%' }}>
      <ReactPlayer
        className="react-player"
        url={preview ? preview.videos?.map((video) => video.fileUrl) : ''}
        width="100%"
        height="100%"
        controls
        playsinline
        playing={false}
        pip={false}
        onContextMenu={(e) => e.preventDefault()}
        config={{
          file: {
            attributes: { crossOrigin: 'anonymous', disablePictureInPicture: true },
            tracks: getTracks(id),
          },
        }}
      />
    </Box>
  );
}
